import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';

const customTheme = {
  overrides: {
    Portal: {
      visualizationWrapperCanvas: {
        height: '90vh',
      },
    },
    AmountPrice: {
      root: {
        right: 24,
      },
    },
  },
};

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    DefaultLayout: {
      visualization: {
        marginTop: 130,
        '& .MuiButtonBase-root': {
          display: 'none',
        },
        [theme.breakpoints.up('sm')]: {
          height: 'calc(100vh - 130px) !important',
        },
      },
      outerContainer: {
        marginTop: '64px !important',
        marginRight: 0,
      },
      productsList: {
        bottom: 'auto !important',
        width: '100% !important',
      },
    },
    CreatorAlignTarget: {
      root: {
        [theme.breakpoints.down('sm')]: {
          maxHeight: 'calc(100% - 180px)',
          marginTop: '80px',
        },
      },
    },
    AmountPrice: {
      root: {
        [theme.breakpoints.up("sm")]: {
          width: '420px',
        }
      },
      card: {
        [theme.breakpoints.down("xs")]: {
          display: 'grid'
        }
      },
      cardUnboxed: {
        [theme.breakpoints.down("xs")]: {
          display: 'grid'
        }
      },
    },
    OptionsList: {
      dialogStyle: {
        [theme.breakpoints.down('xs')]: {
          maxWidth: '100%'
        },
      },
    },
    MuiDialog: {
      paperFullWidth: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        }
      },
      paperScrollPaper: {
        [theme.breakpoints.down('xs')]: {
          maxHeight: '100%'
        }
      },
      paper: {
        [theme.breakpoints.down('xs')]: {
          margin: '0px',
          height: '100%'
        }
      }
    },
    ProductVariant: {
      ProductVariantImageItem: {
        width: '420px',
        height: '210px',
        maxWidth: '450px',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          height: '202px',
        }
      },
      ProductVariantImage: {
        width: '420px',
        height: '210px',
        maxWidth: '450px',
        marginLeft: '-35px',
        marginRight: '35px',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          height: '202px',
        }
      },
      ProductVariantRoot: {
        marginBottom: '10px'
      }
    },
    MuiListItem: {
      root: {
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column'
        }
      }
    }
  });
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
